export default __webpack_public_path__ + "static/media/info.2fb6df96.svg";